import { BlockchainType } from '../../types/services/enums';
import { determineVMType } from './network-validation';
export const determineOrderString = (orderType, // Restrict orderType to valid values
vmType, isSponsored, isWormhole = false) => {
    const networkTypeMap = {
        [BlockchainType.EVM]: 'EVM',
        [BlockchainType.SVM]: 'SOLANA',
        [BlockchainType.MOVE]: 'SUI',
        [BlockchainType.UNKNOWN]: 'UNKNOWN',
    };
    if (isWormhole) {
        return `${vmType}_WORMHOLE${isSponsored ? '_SPONSORED' : ''}`;
    }
    else {
        const networkType = networkTypeMap[vmType];
        if (networkType === 'UNKNOWN') {
            throw new Error('Invalid network to determine action type');
        }
        // Create the string and assert it as GeniusOrderType
        return `${orderType}_${networkType}${isSponsored ? '_SPONSORED' : ''}`;
    }
};
export const determineCrosschainAddresses = (networkIn, networkOut, PKP, orchestrator) => {
    const addressMap = {
        [BlockchainType.EVM]: { pkp: PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress, orch: orchestrator.ethAddress },
        [BlockchainType.SVM]: { pkp: PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress, orch: orchestrator.solanaAddress },
        [BlockchainType.MOVE]: { pkp: PKP === null || PKP === void 0 ? void 0 : PKP.suiAddress, orch: orchestrator.suiAddress },
    };
    const getAddresses = (vmType) => addressMap[vmType] || { pkp: null, orch: null };
    const sourceAddresses = getAddresses(determineVMType(networkIn));
    const destAddresses = getAddresses(determineVMType(networkOut));
    return {
        from: sourceAddresses.pkp,
        recipient: destAddresses.pkp,
        srcOrchestrator: sourceAddresses.orch,
        destOrchestrator: destAddresses.orch,
    };
};
